/* eslint-disable no-console, react/prop-types */
import React, { useState, useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import VerticalNavigation from '@salesforce/design-system-react/components/vertical-navigation';
import { ThemeContext } from '../../context/ThemeContext';
import * as Storage from '../../utilities/storage';
import { CURRENT_USER } from '../../constants/storage';

const menu = [
  {
    id: 'reports',
    label: 'Administration',
    items: [
      {
        id: 'users',
        label: 'Users',
        link: '/settings',
        items: [
          { id: 'user', label: 'Users', link: '/settings' },
          { id: 'metamask', label: 'MetaMask', link: '/settings/metamask' },
          // { id: 'permission', label: 'Permissions', link: 'permission' },
        ],
      },
    ],
  },
];
const secondMenu = [
  // {
  //   id: 'accounts',
  //   label: 'Accounts',
  //   items: [
  //     { id: 'defi_public_address', label: 'Defi Public Addresses', link: 'defi-public-addresses' },
  //     { id: 'exchanges', label: 'Exchanges', link: 'exchanges' },
  //   ],
  // },
  // {
  //   id: 'conditions',
  //   label: 'Conditions',
  //   items: [{ id: 'conditions', label: 'Conditions', link: 'conditions' }],
  // },
  {
    id: 'address_Book',
    label: 'Address Book',
    items: [
      { id: 'contacts', label: 'Contacts', link: '/settings' },
      { id: 'contracts', label: 'Contracts', link: '/settings/contracts' },
      { id: 'network', label: 'Network', link: '/settings/network' },
      { id: 'profile', label: 'Account', link: '/settings/profile' },
      { id: 'password', label: 'Change Password', link: '/settings/change-password' },
      { id: 'metamask', label: 'MetaMask', link: '/settings/metamask' },
    ],
  },
];





const TreeMenu = (props) => {
  const { isDarkTheme, toggleTheme } = useContext(ThemeContext);
  const [selectedId, setSelectedId] = useState('');
  const navigate = useNavigate();
  const [dropdown, setDropdown] = useState(false);
  const storedUser = Storage.get(CURRENT_USER);
  const location = useLocation();


  let secondMenu = [
    {
      id: 'address_Book',
      label: 'Address Book',
      items: [
        { id: 'contacts', label: 'Contacts', link: '/settings' },
        { id: 'contracts', label: 'Contracts', link: '/settings/contracts' },
        { id: 'profile', label: 'Account', link: '/settings/profile' },
        { id: 'metamask', label: 'MetaMask', link: '/settings/metamask' },
      ],
    },
  ];


  if(storedUser?.email){
    secondMenu[0].items.push({ id: 'password', label: 'Change Password', link: '/settings/change-password' },
    )
  }

  if(storedUser?.role === 'manager'){
    secondMenu[0].items.push( { id: 'network', label: 'Network', link: '/settings/network' },
    )
  }

  useEffect(() => {
    const page = location.pathname;
    // if (page === null) {
    //   if (storedUser?.account_type === 'super_admin') {
    //     setSelectedId('/settings');
    //     navigate(`/settings`);
    //   } else {
    //     setSelectedId('/settings/contacts');
    //     navigate(`/settings/contacts`);
    //   }
    // }
    switch (page) {
      case '/settings':
        setSelectedId(storedUser?.role === 'super_admin' ? 'user' : 'contacts');
        setDropdown(true);
        return;
      case '/settings/permission':
        setSelectedId('/settings/permission');
        return;
      case '/settings/label':
        setSelectedId('/settings/label');
        return;
      case '/settings/defi-public-addresses':
        setSelectedId('/settings/defi_public_address');
        return;
      case '/settings/exchanges':
        setSelectedId('/settings/exchanges');
        return;
      case '/settings/conditions':
        setSelectedId('/settings/conditions');
        return;
      case '/settings/contracts':
        setSelectedId('contracts');
        return;
      case '/settings/network':
        setSelectedId('network');
        return;
      case '/settings/profile':
        setSelectedId('profile');
        return;
      case '/settings/change-password':
        setSelectedId('password');
        return;
      case '/settings/metamask':
        setSelectedId('metamask');
        return;
      default:
        return;
    }
  }, [selectedId, storedUser, navigate]);

  const onDropdownclick = (label) => {
    setDropdown(!dropdown);
  };

  const onItemClick = (link, id) => {
    navigate(`${link}`);
  };
  return (
    <>
      {selectedId && (
        <IconSettings iconPath="/assets/icons">
          <div style={{ paddingBottom: '20px' }}>
            {storedUser?.role === 'super_admin' && (
              <div style={{ padding: '0rem 1rem 0rem 1rem' }}>
                <div
                  style={{
                    padding: '.5rem 1rem',
                    paddingLeft: '1.5rem',
                    fontSize: '1rem',
                    fontWeight: '700',
                  }}
                >
                  Administration
                </div>
                {menu[0].items.map((item) =>
                  item.items ? (
                    <div className={`relative`}>
                      <p
                        onClick={() => onDropdownclick(item.items.label)}
                        className={`slds-nav-vertical__item ${
                          selectedId === '/settings/user' || selectedId === '/settings/permission'
                            ? 'parent-tree-nav'
                            : ''
                        }`}
                      >
                        <p className="slds-nav-vertical__action" style={{ display: 'flex' }}>
                          {dropdown ? (
                            <img
                              style={{ marginRight: '0.6rem' }}
                              src="/assets/icons/dropdownIcon.svg"
                              alt="wallet icon"
                            />
                          ) : (
                            <img
                              style={{ marginRight: '0.6rem' }}
                              src="/assets/icons/dropdownSetIcon.svg"
                              alt="wallet icon"
                            />
                          )}

                          {item.label}
                        </p>
                      </p>

                      {dropdown && (
                        <>
                          {item.items.map((item) => (
                            <p
                              className={`slds-nav-vertical__item ${
                                selectedId === item.id ? 'slds-is-active' : ''
                              }`}
                            >
                              <p
                                className="slds-nav-vertical__action"
                                style={{ padding: '.5rem 1.5rem .5rem 4rem' }}
                                onClick={() => onItemClick(item.link, item.id)}
                              >
                                {item.label}
                              </p>
                            </p>
                          ))}
                        </>
                      )}
                    </div>
                  ) : (
                    <p
                      className={`slds-nav-vertical__item ${
                        selectedId === item.id ? 'slds-is-active' : ''
                      }`}
                    >
                      <p
                        onClick={() => navigate(`${item.link}`)}
                        style={{ padding: '.5rem 1.5rem .5rem 2rem' }}
                        className="slds-nav-vertical__action"
                      >
                        {item.label}
                      </p>
                    </p>
                  )
                )}
              </div>
            )}
            {storedUser?.role !== 'super_admin' && (
              <VerticalNavigation
                id="sample-navigation"
                categories={secondMenu}
                selectedId={selectedId}
                onSelect={(event, data) => {
                  onItemClick(data.item.link, data.item.id);
                }}
              />
            )}
            <div style={{ padding: '0rem 1rem 0rem 1rem' }}>
              <div
                style={{
                  padding: '.5rem 1rem',
                  paddingLeft: '1.5rem',
                  fontSize: '1rem',
                  fontWeight: '700',
                }}
              >
                Interface
              </div>
              <div className="slds-nav-vertical__item">
                <p
                  onClick={() => toggleTheme()}
                  style={{ padding: '.5rem 1.5rem .5rem 3rem', cursor: 'pointer' }}
                  className="slds-nav-vertical__action"
                >
                  {' '}
                  Switch to {isDarkTheme ? `Light` : `Dark`} theme{' '}
                </p>
              </div>
            </div>
          </div>
        </IconSettings>
      )}
    </>
  );
};
export default TreeMenu;
